export type Year = number;
export type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type DateType = number;

export type DateWithoutTime = {
  year: Year;
  month: Month;
  date: DateType;
} & {
  __ymd: never;
};

const isMonth = (month: number): month is Month => {
  if (month <= 0 || month > 12) {
    return false;
  }
  return true;
};

export const getYMD = (date: Date): DateWithoutTime => {
  return { year: date.getFullYear(), month: date.getMonth() + 1, date: date.getDate() } as DateWithoutTime;
};

export const toYMD = (ymdObject: { year: Year; month: Month; date: DateType }): DateWithoutTime => {
  return ymdObject as DateWithoutTime;
};

export const isSameYMD = (aDate: DateWithoutTime, bDate: DateWithoutTime) => {
  return aDate.year === bDate.year && aDate.month === bDate.month && aDate.date === bDate.date;
};

export const nextMonth = (ymd: DateWithoutTime): DateWithoutTime => {
  if (ymd.month === 12) {
    return {
      ...ymd,
      year: ymd.year + 1,
      month: 1,
    };
  } else {
    const month = ymd.month + 1;
    if (!isMonth(month)) throw new Error('invalid month');
    return { ...ymd, month: month };
  }
};

export const predMonth = (ymd: DateWithoutTime): DateWithoutTime => {
  if (ymd.month === 1) {
    return {
      ...ymd,
      year: ymd.year - 1,
      month: 12,
    };
  } else {
    const month = ymd.month - 1;
    if (!isMonth(month)) throw new Error('invalid month');
    return { ...ymd, month: month };
  }
};
